export enum DayOfWeek {
  MONDAY = "Pondělí",
  TUESDAY = "Úterý",
  WEDNESDAY = "Středa",
  THURSDAY = "Čtvrtek",
  FRIDAY = "Pátek",
  SATURDAY = "Sobota",
  SUNDAY = "Neděle",
}

export const getDayIndex = (day: string) => {
  switch (day) {
    case "MONDAY":
      return 1;
    case "TUESDAY":
      return 2;
    case "WEDNESDAY":
      return 3;
    case "THURSDAY":
      return 4;
    case "FRIDAY":
      return 5;
    case "SATURDAY":
      return 6;
    case "SUNDAY":
      return 7;
    default:
      return -1;
  }
};
